import { useMutation } from "@tanstack/react-query";

import { queryClient } from "../../../config/react-query";
import { useToast } from "../../../hooks/useToast";
import { fireFolder } from "./actions";

export function useStockFire() {
    const { successToast } = useToast();

    const mutation = useMutation({
        mutationFn: fireFolder,
        onSuccess: () => successToast("Le dossier a été chargé en camion"),
        onSettled: () => {
            queryClient.invalidateQueries({
                queryKey: ["folders"],
            });
        },
    });

    return mutation;
}
